import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import { Stack } from '@servicetitan/design-system/dist/components/Stack/Stack';
import { NotAvailable } from '../not-available';
import { ContactForm } from '../contact-form';
import * as Styles from './widget.module.less';
export const Widget = ({ submitButtonDisabled, textBubble2Color, textBubble1Color, backgroundColor, greetingMessage, confirmationMessage, contactNumber, notAvailable, closeWidget, buttonColor, isSubmitted, isViewMode, isSending, cardColor, message, phone, name, small, handleSubmit, }) => (_jsx(Stack, Object.assign({ style: { backgroundColor }, className: classNames({
        [Styles.widget]: true,
        [Styles.small]: small,
    }), direction: "column" }, { children: notAvailable ? (_jsx(NotAvailable, { phoneNumber: contactNumber, buttonColor: buttonColor, iconColor: buttonColor, closeWidget: closeWidget }, void 0)) : (_jsx(ContactForm, { buttonDisabled: submitButtonDisabled, textBubble2Color: textBubble2Color, textBubble1Color: textBubble1Color, greetingMessage: greetingMessage, confirmationMessage: confirmationMessage, contactNumber: contactNumber, buttonColor: buttonColor, isViewMode: isViewMode, cardColor: cardColor, onSend: handleSubmit, isSending: isSending, isSent: isSubmitted, message: {
            value: isViewMode && isSubmitted ? message.defaultValue : message.value,
            maxLength: message.maxLength,
            onChange: message.onChange,
            error: message.error,
        }, phone: {
            value: isViewMode && isSubmitted ? phone.defaultValue : phone.value,
            onChange: phone.onChange,
            error: phone.error,
        }, name: {
            maxLength: name.maxLength,
            onChange: name.onChange,
            value: name.value,
            error: name.error,
        } }, void 0)) }), void 0));
//# sourceMappingURL=widget.js.map